// extracted by mini-css-extract-plugin
export default {"animation_wrapper":"styles_animation_wrapper__95l4s"};